import ApiModels from '../../api/models';

const getModelsStarted = () => ({
    type: 'GET_MODELS_STARTED'
});

const getModelsSuccess = items => ({
    type: 'GET_MODELS_SUCCESS',
    payload: items
});

const getModelsFailure = error => ({
    type: 'GET_MODELS_FAILURE',
    payload: { error }
});

const getModels = (idMake) => {

    return dispatch => {

        dispatch(getModelsStarted());

        ApiModels.get(idMake)
            .then(json =>  {
                const items = json.models;
                dispatch(getModelsSuccess({ items })) 
            })
            .catch(error => dispatch(getModelsFailure(error)));

    }
    
}

const setSelectedModel = model => {
    return {
        type: 'SET_SELECTED_MODEL',
        payload: model
    }
}

export default { getModels, setSelectedModel };